import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import headBgImage from '../../assets/images/my_business/gas_station.png';

const StyledContainer = styled.div`
	position: relative;
	padding: 20px;
	height: 100%;
`;

const StyledHeadContainer = styled.div`
	position: relative;
	width: 100%;
	height: 240px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 17px 20px 16px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	overflow: hidden;
`;

const StyledHeadTopContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3px;
`;

const StyledHeadBottomContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 7px;
`;

const StyledHeadPriceContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}

	img {
		opacity: 0.5;
	}
`;

const StyledHeadBgImage = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-image: url(${headBgImage});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	mask-image: linear-gradient(
		90deg,
		rgba(255, 255, 255, 0) 0%,
		rgba(255, 255, 255, 0) 20.32%,
		#ffffff 100%
	);
`;

const StyledInfoGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 160px 160px;
	gap: 10px;
	margin-top: 20px;
`;

const StyledButtonsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 10px;
`;

export {
	StyledButtonsGrid,
	StyledContainer,
	StyledHeadBgImage,
	StyledHeadBottomContainer,
	StyledHeadContainer,
	StyledHeadPriceContainer,
	StyledHeadTopContainer,
	StyledInfoGrid,
};
